import React from 'react';
import PropTypes from 'prop-types';

import {styled} from "@mui/material/styles";

import CustomTooltip from "components/CustomTooltip";

import {black500, grey25, greyishBlue200} from "assets/jss/main";

ListingIconButton.propTypes = {
    icon: PropTypes.elementType.isRequired,
    tooltip: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

const StyledButton = styled('button')({
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: 'unset',
    backgroundColor: '#fff',
    border: `1px solid ${greyishBlue200}`,
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover:not(:disabled)': {
        backgroundColor: grey25
    },
    '&:disabled': {
        cursor: 'default',
        opacity: 0.5
    },
    'svg': {
        width: '16px',
        height: '16px'
    },
    'svg path': {
        stroke: black500
    }
});

function ListingIconButton({icon: Icon, tooltip, ...props}) {
    const button = (
        <StyledButton type="button" {...props}>
            <Icon/>
        </StyledButton>
    );

    if (!tooltip) {
        return button;
    }

    return (
        <CustomTooltip title={tooltip}>
            {button}
        </CustomTooltip>
    );
}

export default ListingIconButton;
